import { defineStore } from 'pinia'
import axios from 'axios'
import { isAfter } from '~~/helpers/dates'

export const useUserStore = defineStore('user', () => {
    const data = ref({})

    const { $startLoading, $stopLoading } = useNuxtApp()

    const getData = () => data.value

    const getUser = async() => {
        const config = useRuntimeConfig()

        axios.defaults.withCredentials = true
        axios.defaults.headers.common['Accept'] = 'application/json'
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
        axios.defaults.xsrfCookieName = 'XSRF-TOKEN'
        axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN'


        $startLoading()
        
        const { data } = await axios.get(config.public.api_url + 'user')

        $stopLoading()

        setData(data.data)
    }

    const setData = user => {
        data.value = user
    }

    const logoutUser = () => {
        setData({})
    }

    const isSuperAdmin = computed(() => data.value && data.value.role === 5)

    const isAdmin = computed(() => data.value && data.value.role >= 4)

    const isAtLeastManager = computed(() => data.value && data.value.role >= 3)

    const isManager = computed(() => data.value && data.value.role === 3)

    const isAccount = computed(() => data.value && data.value.account_id != null)

    const isTrainer = computed(() => data.value && data.value.trainer_id != null)

    const isCustomer = computed(() => data.value && data.value.role === 0)

    const isGuest = computed(() => ! data.value || Object.keys(data.value).length === 0)

    const canUndoAppointment = date => {
        let now = new Date()
    
        const next24hours = now.addDays(1)

        return isAdmin.value || isAfter(new Date(date), next24hours)
    }

    return {
        data,
        getData,
        getUser,
        setData,
        logoutUser,
        isSuperAdmin,
        isAdmin,
        isAtLeastManager,
        isManager,
        isAccount,
        isTrainer,
        isCustomer,
        isGuest,
        canUndoAppointment,
    }
})
